module.exports = __webpack_public_path__ + "img/ja.8b86a460.svg";